const route = {
	name: 'reports',
	path: '/reports',
	redirect: '/reports/list',
	component: () => import('@/components/reports/reports'),
	children: [
		{
			name: 'reports-list',
			path: '/reports/list',
			meta: {
				title: 'Reportes',
			},
			component: () => import('@/components/reports/reports-list'),
		},
		{
			name: 'report-in-out',
			path: '/reports/in/out',
			meta: {
				title: 'Reporte IN/OUT',
			},
			component: () => import('@/pages/reports/pages-reports-in-out'),
		},
		{
			name: 'utilities-by-warehouse',
			path: '/reports/utilities-by-warehouse',
			meta: {
				title: 'Reporte de Utilidades por Tienda',
			},
			component: () => import('@/pages/reports/pages-reports-utilities-by-warehouse'),
		},
		{
			name: 'rotation-report',
			path: '/reports/rotation',
			meta: {
				title: 'Reporte de Rotación',
			},
			component: () => import('@/pages/reports/pages-reports-rotation'),
		},
		{
			name: 'reports-transfers-detail',
			path: '/reports/transfer-detail',
			meta: {
				title: 'REPORTE DE PRODUCTOS DEVUELTOS',
			},
			component: () => import('@/pages/reports/pages-reports-transfer-detail'),
		},
		{
			name: 'sales-category',
			path: '/reports/sales-category',
			component: () => import('@/pages/reports/pages-reports-sales-category'),
			meta: {
				title: 'Reporte de Venta por Categoría',
			},
		},
		{
			name: 'detail-report-category',
			path: '/reports/detail-sales-category/:id?',
			meta: {
				title: 'Detalle de la Categoría',
			},
			component: () => import('@/pages/reports/pages-detail-reports-sales-category'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/reports.js